<template>
<div class="chapter">
<div class="inner_page">
<p class="center" style="text-align:center"><span>Books by Penelope Lively</span></p>
<p class="linespace">
</p><p class="center" style="text-align:center"><span><i>fiction</i></span></p>
<p class="halfline">
</p><p class="center" style="text-align:center"><span><span class="fsc">THE ROAD TO LICHFIELD</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">NOTHING MISSING BUT THE SAMOVAR</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">TREASURES OF TIME</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">JUDGEMENT DAY</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">NEXT TO NATURE, ART</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">PERFECT HAPPINESS</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">CORRUPTION</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">ACCORDING TO MARK</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">PACK OF CARDS</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">MOON TIGER</span></span></p>
<p class="linespace">
</p><p class="center" style="text-align:center"><span><i>for children</i></span></p>
<p class="halfline">
</p><p class="center" style="text-align:center"><span><span class="fsc">ASTERCOTE</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE WHISPERING KNIGHTS</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE WILD HUNT OF HAGWORTHY</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE DRIFTWAY</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE GHOST OF THOMAS KEMPE</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE HOUSE IN NORHAM GARDENS</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">GOING BACK</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">BOY WITHOUT A NAME</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE STAINED GLASS WINDOW</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">A STITCH IN TIME</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">FANNY'S SISTER</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE VOYAGE OF QV66</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">FANNY AND THE MONSTERS</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">FANNY AND THE BATTLE OF POTTER'S PIECE</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">THE REVENGE OF SAMUEL STOKES</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">UNINVITED GHOSTS AND OTHER STORIES</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">DRAGON TROUBLE</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">A HOUSE INSIDE OUT</span></span></p>
<p class="linespace">
</p><p class="center" style="text-align:center"><span><i>nonfiction</i></span></p>
<p class="halfline">
</p><p class="center" style="text-align:center"><span><span class="fsc">THE PRESENCE OF THE PAST:</span></span></p>
<p class="center" style="text-align:center"><span><span class="fsc">AN INTRODUCTION TO LANDSCAPE HISTORY</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Books_By.vue?380f58e0